import { CartProductType, type CartProduct } from '@/app/[locale]/order/_context/order-flow-context'

/**
 * @returns `true` when the cart has at least one line and every line is `ANNUAL_PROGRAM_FAMILY`.
 */
export function isAllAnnualProgramFamily(cartProducts: CartProduct[]): boolean {
	return (
		cartProducts.length > 0 &&
		cartProducts.every(p => p.type === CartProductType.ANNUAL_PROGRAM_FAMILY)
	)
}
